import React from 'react';
import ReactDOM from 'react-dom';



export default class Message extends React.Component {
  render() {

    var content = ""

    for(var i = 0; i < 1000; i ++)
    {
        content += this.props.message
    }

    return (


        <div style={this.props.style} id="message">{content}</div>

    );
  }
}
